import React, { createContext, useContext, ReactNode } from 'react';

/**
 * ModalContainerContext
 *
 * Provides a reference to the modal container element for portaling modals.
 * Modals are rendered into the #modal-root div for better organization
 * and to ensure proper stacking context.
 */
interface ModalContainerContextType {
  container: HTMLElement | null;
}

const ModalContainerContext = createContext<ModalContainerContextType>({
  container: null,
});

export const useModalContainer = () => {
  const context = useContext(ModalContainerContext);
  return context.container;
};

interface ModalContainerProviderProps {
  container: HTMLElement | null;
  children: ReactNode;
}

export const ModalContainerProvider: React.FC<ModalContainerProviderProps> = ({
  container,
  children,
}) => {
  return (
    <ModalContainerContext.Provider value={{ container }}>
      {children}
    </ModalContainerContext.Provider>
  );
};
